import { IOrderHistoryTableData } from '../../../actions/order-history/get-order-history.action';
import { UNKNOWN_STATUS_CODE } from '../../../utilities/status-visual-group';

export const DEMO_ORDERS: IOrderHistoryTableData[] = [
    {
        OrderNumber: 'DEMO-4502125',
        PoNumber: 'PO-2026-0425',
        StateLogistics: '05',
        StateInvoice: UNKNOWN_STATUS_CODE,
        Status: '',
        ConfirmedDate: '2026-07-14T00:00:00Z',
        RecordCreatedDate: '2026-07-14T00:00:00Z',
        SoldToId: '1000005',
        SoldToName: 'Bayer MaterialScience AG',
        ShipToId: '2000006',
        ShipToName: 'Leverkusen Werk',
        OrderLines: [],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502124',
        PoNumber: '',
        StateLogistics: UNKNOWN_STATUS_CODE,
        StateInvoice: UNKNOWN_STATUS_CODE,
        Status: '',
        ConfirmedDate: '2026-07-13T00:00:00Z',
        RecordCreatedDate: '2026-07-13T00:00:00Z',
        SoldToId: '1000006',
        SoldToName: 'BASF Coatings GmbH',
        ShipToId: '2000007',
        ShipToName: 'Münster Distribution',
        OrderLines: [],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502118',
        PoNumber: 'PO-2026-0420',
        StateLogistics: '10',
        StateInvoice: UNKNOWN_STATUS_CODE,
        Status: '',
        ConfirmedDate: '2026-07-01T00:00:00Z',
        RecordCreatedDate: '2026-07-01T00:00:00Z',
        SoldToId: '1000001',
        SoldToName: 'Müller Chemie GmbH',
        ShipToId: '2000001',
        ShipToName: 'Krefeld-Uerdingen Plant',
        OrderLines: [],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502095',
        PoNumber: 'PO-2026-0417',
        StateLogistics: '20',
        StateInvoice: '20',
        Status: '',
        ConfirmedDate: '2026-06-28T00:00:00Z',
        RecordCreatedDate: '2026-06-28T00:00:00Z',
        SoldToId: '1000003',
        SoldToName: 'Nordic Coatings A/S',
        ShipToId: '2000003',
        ShipToName: 'Linz Warehouse',
        OrderLines: [],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502090',
        PoNumber: 'PO-2026-0418',
        StateLogistics: '30',
        StateInvoice: UNKNOWN_STATUS_CODE,
        Status: '',
        ConfirmedDate: '2026-06-25T00:00:00Z',
        RecordCreatedDate: '2026-06-25T00:00:00Z',
        SoldToId: '1000002',
        SoldToName: 'Alpine Polymers AG',
        ShipToId: '2000002',
        ShipToName: 'Antwerp Warehouse',
        OrderLines: [],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502075',
        PoNumber: 'PO-2026-0411',
        StateLogistics: '50',
        StateInvoice: UNKNOWN_STATUS_CODE,
        Status: '',
        ConfirmedDate: '2026-06-20T00:00:00Z',
        RecordCreatedDate: '2026-06-20T00:00:00Z',
        SoldToId: '1000003',
        SoldToName: 'Nordic Coatings A/S',
        ShipToId: '2000003',
        ShipToName: 'Linz Warehouse',
        OrderLines: [
            {
                OrderNumber: 'DEMO-4502075',
                LineNumber: '10',
                DeliveryNumber: '88231',
                ProductName: 'Sample Product A',
                StateLogistics: '50',
                StateInvoice: UNKNOWN_STATUS_CODE,
                Status: '',
                RequestedQty: '500',
                RequestedUnit: 'KG',
                Currency: 'EUR',
                NetValue: '12500',
                ProductNumber: '',
                ScheduleLines: [],
                ExtensionProperties: []
            }
        ],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502061',
        PoNumber: 'PO-2026-0402',
        StateLogistics: '70',
        StateInvoice: '60',
        Status: '',
        ConfirmedDate: '2026-06-15T00:00:00Z',
        RecordCreatedDate: '2026-06-15T00:00:00Z',
        SoldToId: '1000001',
        SoldToName: 'Müller Chemie GmbH',
        ShipToId: '2000001',
        ShipToName: 'Krefeld-Uerdingen Plant',
        OrderLines: [
            {
                OrderNumber: 'DEMO-4502061',
                LineNumber: '10',
                DeliveryNumber: '88229',
                ProductName: 'Sample Product B',
                StateLogistics: '70',
                StateInvoice: '60',
                Status: '',
                RequestedQty: '250',
                RequestedUnit: 'KG',
                Currency: 'EUR',
                NetValue: '6250',
                ProductNumber: '',
                ScheduleLines: [],
                ExtensionProperties: []
            },
            {
                OrderNumber: 'DEMO-4502061',
                LineNumber: '20',
                DeliveryNumber: '88230',
                ProductName: 'Sample Product B2',
                StateLogistics: '70',
                StateInvoice: '60',
                Status: '',
                RequestedQty: '125',
                RequestedUnit: 'KG',
                Currency: 'EUR',
                NetValue: '3125',
                ProductNumber: '',
                ScheduleLines: [],
                ExtensionProperties: []
            }
        ],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502044',
        PoNumber: 'PO-2026-0398',
        StateLogistics: '70',
        StateInvoice: '80',
        Status: '',
        ConfirmedDate: '2026-06-12T00:00:00Z',
        RecordCreatedDate: '2026-06-12T00:00:00Z',
        SoldToId: '1000004',
        SoldToName: 'Rhein Kunststoff KG',
        ShipToId: '2000004',
        ShipToName: 'Mannheim Site',
        OrderLines: [
            {
                OrderNumber: 'DEMO-4502044',
                LineNumber: '10',
                DeliveryNumber: '88218',
                ProductName: 'Sample Product C',
                StateLogistics: '70',
                StateInvoice: '80',
                Status: '',
                RequestedQty: '1000',
                RequestedUnit: 'KG',
                Currency: 'EUR',
                NetValue: '25000',
                ProductNumber: '',
                ScheduleLines: [],
                ExtensionProperties: []
            }
        ],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502032',
        PoNumber: 'PO-2026-0391',
        StateLogistics: '80',
        StateInvoice: '60',
        Status: '',
        ConfirmedDate: '2026-06-08T00:00:00Z',
        RecordCreatedDate: '2026-06-08T00:00:00Z',
        SoldToId: '1000002',
        SoldToName: 'Alpine Polymers AG',
        ShipToId: '2000005',
        ShipToName: 'Hamburg Storage',
        OrderLines: [
            {
                OrderNumber: 'DEMO-4502032',
                LineNumber: '10',
                DeliveryNumber: '88205',
                ProductName: 'Sample Product D',
                StateLogistics: '80',
                StateInvoice: '60',
                Status: '',
                RequestedQty: '750',
                RequestedUnit: 'KG',
                Currency: 'EUR',
                NetValue: '18750',
                ProductNumber: '',
                ScheduleLines: [],
                ExtensionProperties: []
            }
        ],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502019',
        PoNumber: 'PO-2026-0388',
        StateLogistics: '30',
        StateInvoice: UNKNOWN_STATUS_CODE,
        Status: '',
        ConfirmedDate: '2026-06-05T00:00:00Z',
        RecordCreatedDate: '2026-06-05T00:00:00Z',
        SoldToId: '1000003',
        SoldToName: 'Nordic Coatings A/S',
        ShipToId: '2000003',
        ShipToName: 'Linz Warehouse',
        OrderLines: [],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4502007',
        PoNumber: 'PO-2026-0377',
        StateLogistics: '90',
        StateInvoice: '80',
        Status: '',
        ConfirmedDate: '2026-05-28T00:00:00Z',
        RecordCreatedDate: '2026-05-28T00:00:00Z',
        SoldToId: '1000004',
        SoldToName: 'Rhein Kunststoff KG',
        ShipToId: '2000004',
        ShipToName: 'Mannheim Site',
        OrderLines: [
            {
                OrderNumber: 'DEMO-4502007',
                LineNumber: '10',
                DeliveryNumber: '88198',
                ProductName: 'Sample Product E',
                StateLogistics: '90',
                StateInvoice: '80',
                Status: '',
                RequestedQty: '2000',
                RequestedUnit: 'KG',
                Currency: 'EUR',
                NetValue: '50000',
                ProductNumber: '',
                ScheduleLines: [],
                ExtensionProperties: []
            }
        ],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    },
    {
        OrderNumber: 'DEMO-4501987',
        PoNumber: 'PO-2026-0354',
        StateLogistics: '10',
        StateInvoice: UNKNOWN_STATUS_CODE,
        Status: '',
        ConfirmedDate: '2026-05-20T00:00:00Z',
        RecordCreatedDate: '2026-05-20T00:00:00Z',
        SoldToId: '1000002',
        SoldToName: 'Alpine Polymers AG',
        ShipToId: '2000002',
        ShipToName: 'Antwerp Warehouse',
        OrderLines: [],
        ExtensionProperties: [],
        highlight: false,
        highlightOrderLines: false
    }
];
